import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ProjectReportingPage from "@/pages/admin/ProjectReportingPage";

export const Route = createFileRoute("/_admin/admin/project-reporting")({
  head: () => pageHead("Admin · Project Reporting", "AKIVA admin · project reporting portal.", "/admin/project-reporting", true),
  component: ProjectReportingPage,
});
